import { Button } from '@cgn/framework-ui-components/v2';
import React from 'react';
import { CampagnaPianiValore } from '../../domain/eccellenza/eccellenza';

const BottoneScopriPianiEccellenza = () => {
  const handleClick = () => {
    window.open(CampagnaPianiValore, '_blank');
  };

  return (
    <Button
      emphasis={Button.Emphasis.HIGH}
      onClick={handleClick}
    >
      Scopri di più sui piani CGN
    </Button>
  );
};

export default BottoneScopriPianiEccellenza;
